<template>
  <div class="paddBottom">
    <IndexHeaderOthers ref="indexHeader"></IndexHeaderOthers>
    <div class="main">
      <div class="conner">
        <div class="formSubMain">
          <el-form ref="form" :model="form">
            <el-form-item label="Title:" :required="true">
              <el-input v-model="form.title" placeholder="Please enter the content" disabled></el-input>
            </el-form-item>
            <el-form-item label="Object_name:">
              <el-input v-model="form.objectName" placeholder="Please enter the content" disabled></el-input>
            </el-form-item>
            <el-form-item label="Object_Class:">
              <el-select v-model="form.objectClass" filterable placeholder="Please choose" disabled>
                <el-option v-for="(item, index) in objectClassList" :key="index" :label="item.name"
                           :value="item.name" ></el-option>
              </el-select>
            </el-form-item>

            <!--	<el-form-item label="Event_Name:">
                    <el-select
                                           style="width:100%"
                                           v-model="form.objectName"
                                           clearable
                                           filterable
                                           placeholder="Variables"
                                           v-selectLoadMore="selectLoadMore"
                                           :loading="loading"
                                           remote
                                           class="objectName"
                                           :remote-method="remoteMethod"
                                           @change="changeValue"
                                           >
                                  <el-option v-for="item in options" :key="item.value" :label="item.name"
                                      :value="item.name">
                                  </el-option>
                                </el-select>
                </el-form-item>
            -->
            <el-form-item label="Telescope:">
              <el-select v-model="form.telescope" filterable placeholder="Variables" allow-create
                         class="objectName" style="width: 100%" disabled>
                <el-option v-for="item in telescopeList" :key="item.value" :label="item.name"
                           :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Trigger_Time:">
              <el-date-picker v-model="form.triggerTime" type="datetime"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              placeholder="eg:2022-11-11 12:00:00" :picker-options="pickerOptions0" disabled>
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Ra:">
              <el-input v-model="form.ra" placeholder="Please enter the content" disabled></el-input>
            </el-form-item>
            <el-form-item label="DEC:">
              <el-input v-model="form.declination" placeholder="Please enter the content" disabled></el-input>
            </el-form-item>
            <el-form-item label="Error:">
              <el-input v-model="form.positioningError" placeholder="Please enter the content" disabled></el-input>
            </el-form-item>
            <!--						上传文件改造 start-->
            <el-form-item label="Related_files:">
              <div v-for="(item, index) in urlList" :key="index">

<!--                <el-input v-model="urlList[index]" style="width: 100%"-->
<!--                          placeholder="Http://" disabled></el-input>-->
                <el-image
                    style="width: 200px; height: 200px;"
                    :src="urlList[index]"
                    :fit="fit"></el-image>
              </div>
            </el-form-item>
            <!--						上传文件改造 end-->
            <el-form-item label="Email:">
              <el-input v-model="form.email" placeholder="Please enter the content" disabled></el-input>
            </el-form-item>
            <el-form-item label="Comments:">
              <quill-editor :options="editorOption" v-model="form.comments">
              </quill-editor>
            </el-form-item>
            <!--						<el-form-item label=" ">-->
            <!--							<div class="flexWrap">-->
            <!--								<el-input v-model="form.attachmentName" style="width: 388px" disabled-->
            <!--									placeholder="Please select a file to upload"></el-input>-->
            <!--								<div>-->
            <!--									<el-upload class="upload-demo" :action="actionUrl" :on-success="upload_successfile"-->
            <!--										:on-error="upload_errorfile" multiple>-->
            <!--										<el-button size="small" type="primary" class="btn QSe">Select</el-button>-->
            <!--									</el-upload>-->
            <!--								</div>-->
            <!--							</div>-->
            <!--						</el-form-item>-->

<!--            <el-form-item style="margin: 40px 0">-->
<!--              <div class="flexCenter">-->
<!--                <div class="cancel">Cancel</div>-->
<!--                <div class="submit" @click="onSubmit">Submit</div>-->
<!--              </div>-->
<!--            </el-form-item>-->
          </el-form>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import IndexHeaderOthers from "./header/indexHeaderOthers.vue";

export default {
  name: "showSubmitInfo",
  components:{
    IndexHeaderOthers,
  },
  data(){
    return{
      parmasData:{},
      form: {
        title: "",
        objectClass: "",
        objectName: "",
        telescope: "",
        triggerTime: "",
        ra: "",
        declination: "",
        email: "",
        positioningError: "",
        comments: "",
        attachment: "",
        checkList: "Picture",
        caption: "",
        attachmentName: '',
        lcUrl: ''
      },
      urlList:[],
      tagsList:[],
      attachmentList:[],
      pickerOptions0: {
        disabledDate: (time) => {
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
              1000 - 1);
          return time.getTime() >
              new Date().getTime() + (start - new Date().getTime());

        }
      },
      editorOption: {
        placeholder: 'please enter the Comments'
      },
      objectClassList: [],
      telescopeList: [],
      urlListNew:[],
      tagsListNew:[]
    };
  },
  mounted(){
    const parmasData=this.$route.query.constid;
    this.getData(parmasData);
  },
  methods:{
    getData(dataId){
      this.$fetchGet("/cms-middle/astronCustomize/queryById1", {
        id: dataId,
      }).then((res) => {
        this.form=res.astronCustomize.data;
        console.log("这是form表单内容：",this.form);
        this.urlListNew=res.astronCustomize.urlsList;
        this.tagsListNew=res.astronCustomize.tagsList;
        this.urlListNew.forEach((item) =>{
          this.urlList.push(item);
        });
       this.tagsListNew.forEach((item)=>{
          this.tagsList.push(item);
        });
      }).catch((err) => {

      });

    }
  }
}
</script>

<style lang="less">
.paddBottom{
  padding-bottom: 0px;
}
.conner {
  width: 1050px;
  margin: 0 auto;
  text-align: left;
}
.conner-top {
  padding-top: 48px;
  display: flex;
}
.main {
  position: relative;
  margin-top: -70px;
  z-index: 99;
  width: 100%;
  height: auto;
  background: #fff;
  border-radius: 0 120px 0 0;
}
.pageBlock {
  margin-top: 28px;
  height: 44px;
  display: flex;
  align-items: center;
  margin-bottom: 52px;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 84px;
  height: 84px;
}

.el-upload-list--picture-card .el-upload-list__item-actions {
  font-size: 14px;
}

.QSe,
.Add,
.Rem {
  width: 105px;
  height: 36px;
  background: #168ec7;
  border-radius: 5px;
  text-align: center;
  line-height: 36px;
  color: #fff;
  margin-left: 10px;
  cursor: pointer;
}

.url_item,
.items {
  display: flex;
  align-items: center;
}
</style>